import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { InvoiceInfo } from '../constants/constants';
import { HttpClient } from '@angular/common/http';

export interface PaymentInfo {
  clientSecret: string;
  invoiceData: InvoiceInfo | null;
}

export interface GeneratedPyamentInfo {
  invoiceTransactionCharges: number;
  invoiceDiscount: number;
  invoiceDescription: string;
  invoiceRecurringIntervalCount: number;
  invoiceRecurringInterval: number;
  clientSecret: string;
  invoiceAmount: number;
  subscriptionId: string;
  invoiceStatus: number;
  invoiceIterations: number;
}

@Injectable({
  providedIn: 'root',
})
export class StripePaymentService {
  paymentInfo: BehaviorSubject<PaymentInfo> = new BehaviorSubject(<PaymentInfo>{
    clientSecret: '',
    invoiceData: null,
  });

  constructor(private http: HttpClient) {}

  getPaymentInfo(): Observable<PaymentInfo> {
    return this.paymentInfo.asObservable();
  }

  setPaymentInfo(paymentInfo: PaymentInfo): void {
    this.paymentInfo.next(paymentInfo);
  }

  getGeneratedPaymentInfo(
    invoiceId: string,
    clientSecret: string
  ): Observable<any> {
    return this.http.get(
      `/api/invoice/subscription/${invoiceId}/${clientSecret}`
    );
  }
}
